import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AuthService, PublicPlateau } from '../../core/auth.service';

@Component({
  selector: 'app-register-page',
  standalone: true,
  imports: [FormsModule, NgFor, NgIf, RouterLink],
  templateUrl: './register.page.html',
  styleUrl: './register.page.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RegisterPageComponent implements OnInit {
  firstName = '';
  lastName = '';
  email = '';
  password = '';
  confirmPassword = '';
  plateauId: number | null = null;
  plateaux: PublicPlateau[] = [];
  message = '';
  errorMessage = '';
  isLoading = false;
  isLoadingPlateaux = false;

  constructor(
    private readonly authService: AuthService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadPlateaux();
  }

  private loadPlateaux(): void {
    this.isLoadingPlateaux = true;
    this.authService.listPublicPlateaux().subscribe({
      next: response => {
        this.plateaux = response;
        if (!this.plateauId && response.length > 0) {
          this.plateauId = response[0].id;
        }
        this.isLoadingPlateaux = false;
        this.cdr.markForCheck();
      },
      error: () => {
        this.isLoadingPlateaux = false;
        this.errorMessage = 'Impossible de charger les plateaux.';
        this.cdr.markForCheck();
      }
    });
  }

  submit(): void {
    if (!this.firstName || !this.lastName || !this.email || !this.password || !this.confirmPassword) {
      this.errorMessage = 'Veuillez compléter tous les champs.';
      this.message = '';
      return;
    }
    if (!this.plateauId) {
      this.errorMessage = 'Veuillez sélectionner un plateau.';
      this.message = '';
      return;
    }
    if (this.password !== this.confirmPassword) {
      this.errorMessage = 'Les mots de passe ne correspondent pas.';
      this.message = '';
      return;
    }
    this.errorMessage = '';
    this.message = '';
    this.isLoading = true;
    this.authService
      .register({
        email: this.email,
        prenom: this.firstName,
        nom: this.lastName,
        password: this.password,
        plateauId: this.plateauId
      })
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.message = 'Votre compte a bien été créé. Vous pouvez vous connecter.';
          this.cdr.markForCheck();
        },
        error: error => {
          this.isLoading = false;
          if (error?.status === 409) {
            this.errorMessage = 'Cet email est déjà utilisé.';
          } else {
            this.errorMessage = 'Impossible de créer le compte. Réessayez plus tard.';
          }
          this.cdr.markForCheck();
        }
      });
  }
}
